/**
 * переводит настройки позиционирования chartJs в настройки tether
 * (они совпадают кроме позиции по центру: в chartJs - center, а в tether - middle)
 */
// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
function translateAlign(align) {
    return align === 'center' ? 'middle' : align;
}
/**
 * @param chartJsTooltip тултип chartJs
 * @return настройки tether для позиционирования
 */

// eslint-disable-next-line no-restricted-syntax -- TODO: legacy function declaration (baseline)
export function tetherOptionsFromChartJsTooltip(chartJsTooltip) {
    const { xAlign, yAlign, caretX, caretY } = chartJsTooltip;

    return {
        attachment: `${translateAlign(yAlign)} ${translateAlign(xAlign)}`,
        targetAttachment: 'top left',
        targetOffset: `${caretY}px ${caretX}px`
    };
}
